import {lazy} from "react";
import {usrPermission} from "../../config/userPermission";

// const AboutEvents = lazy(() => import("./pages/AboutEvents"));
const Message = lazy(() => import("./pages/Message"));

export const routes: any = [
    {
        path: "message",
        permission: usrPermission.message.r,
        element: < Message/>,
    },
];